import { type FC, useState } from 'react';
import { Trans } from 'react-i18next';
import styled from 'styled-components';

import { Modal } from '@soluto-private/aui-react-modal';
import { Action, Text } from '@soluto-private/mx-asurion-ui-react';

import { useAnalytics } from '@service-initiation/shared-data-access-analytics';
import { Spacer } from '@service-initiation/shared-ui-spacer';
import { TranslationEntries } from '@service-initiation/tech-care-data-access-i18n';

const ClaimsOffRampContainer = styled.div`
  padding-bottom: 32px;
`;

type ClaimsOffRampProps = {
  paddingTop?: string;
};

const CLAIMS_OFFRAMP_TEXT = TranslationEntries.Repairs.ClaimsOfframp;

export const ClaimsOffRamp: FC<ClaimsOffRampProps> = ({ paddingTop }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { dispatchClickEvent } = useAnalytics();

  return (
    <>
      <Modal
        ariaLabel="Devices covered by protection plans"
        isOpen={isOpen}
        onCloseModal={() => {
          dispatchClickEvent('CloseModalX', {
            Cta: 'Close Modal',
          });
          return setIsOpen(false);
        }}
      >
        <Modal.Header>
          <Text size={5}>Devices covered by protection plans</Text>
        </Modal.Header>
        <Modal.Content>
          <Trans
            components={{
              Link: (
                <Action
                  href="https://www.asurion.com/claims/"
                  onClick={() => {
                    dispatchClickEvent('LinkClick', {
                      Cta: 'Start a claim',
                      LinkTo: 'A.com claims page',
                    });
                  }}
                  style={{ paddingRight: '0.2em' }}
                  target="_blank"
                  variant="flat"
                />
              ),
            }}
            i18nKey={CLAIMS_OFFRAMP_TEXT.StartAClaim}
          />

          <Spacer size={32} />
          <Trans
            components={{
              Link: (
                <Action
                  href="https://www.asurion.com/myaccount/"
                  onClick={() => {
                    dispatchClickEvent('LinkClick', {
                      Cta: 'Sign into your account',
                      LinkTo: 'A.com login page',
                    });
                  }}
                  state="enabled"
                  target="_blank"
                  variant="flat"
                />
              ),
            }}
            i18nKey={CLAIMS_OFFRAMP_TEXT.SignIntoYourAccount}
          />
          <Spacer size={32} />
          <Trans i18nKey={CLAIMS_OFFRAMP_TEXT.SamsungGoogleExtendedWarranty} />
          <Spacer size={32} />
        </Modal.Content>
        <Modal.Footer>
          <Action
            onClick={() => {
              dispatchClickEvent('CloseModalButton', {
                Cta: 'Close Modal',
              });
              return setIsOpen(false);
            }}
            size="md"
          >
            Close
          </Action>
        </Modal.Footer>
      </Modal>
      <ClaimsOffRampContainer style={{ paddingTop }}>
        <div>
          <Trans
            components={{
              Link: (
                <Action
                  data-analytics-action-id="LinkClick"
                  data-analytics-cta="Start a claim"
                  data-testid="start-a-claim-link"
                  href="https://www.asurion.com/claims/"
                  target="_blank"
                  variant="flat"
                />
              ),
            }}
            i18nKey={CLAIMS_OFFRAMP_TEXT.Line1}
          />
        </div>

        <div>
          <Trans
            components={{
              Button: (
                <Action
                  data-analytics-action-id="LinkClick"
                  data-analytics-cta="Learn more"
                  data-testid="learn-more-link"
                  onClick={() => setIsOpen(true)}
                  style={{ paddingLeft: '0.2em' }}
                  variant="flat"
                />
              ),
            }}
            i18nKey={CLAIMS_OFFRAMP_TEXT.Line2}
          />
        </div>
      </ClaimsOffRampContainer>
    </>
  );
};
